import React from 'react';
import Topbar from '../components/Nav/Topbar';

const MainLayout = ({children}) => {
  return (
    <div className="flex h-screen">
      <div className="flex-1 flex flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-2 bg-gray-50">
         {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;